import axios from "axios";
import moment from "moment";
import { ONBOARDING_API_ENDPOINT } from "../../../config/url.config";
import { navigateToSessionExpired } from "../../../utils/sessionExpired";
import { documentsWasUpdatedByUser } from "../../../utils/updatedByUser";
import { getAuthHeader } from "../../../utils/superFetch";

export const handleLoadVehicleLog = (itemIndex, requirementDocuments, setCarInsuranceDetails, setCarInsurancePicture,logdetails, setUserUploadedInsurancePic ) => {
    setCarInsurancePicture(logdetails)
    for(let requiredItems of requirementDocuments[itemIndex].requiredItems) {
      if(requiredItems.itemName === 'carInsurance' && requiredItems.value !== "") {
        setCarInsurancePicture(requiredItems.url)
        setUserUploadedInsurancePic(true);
      }
      if(requiredItems.itemName === 'insuranceCompany' && requiredItems.value !== "") {
        setCarInsuranceDetails(carInsuranceDetails => ({...carInsuranceDetails, carInsuranceCompany: requiredItems.value}))
      }
      if(requiredItems.itemName === 'insuranceExpiryDate' && requiredItems.value !== "") {
        setCarInsuranceDetails(carInsuranceDetails => ({...carInsuranceDetails, carInsuranceExpiryDate: requiredItems.value}))
      }
    }
}

export const handleCarInsuranceClick = (vehicleLogRef) => {
  vehicleLogRef.current.click();
}

export const updateMemberRequirement = (memberRequirement,setMemberRequirement, itemIndex, itemName, updatedValue, updatedUrl) => {
  let tmpData = {...memberRequirement}
  for (let i = 0 ; i< tmpData.requiredDocuments[itemIndex].requiredItems.length ;i++) {
    if (
      itemName === tmpData.requiredDocuments[itemIndex].requiredItems[i].itemName
    ) {
      if(tmpData.requiredDocuments[itemIndex].requiredItems[i].status === 2 || 
        tmpData.requiredDocuments[itemIndex].requiredItems[i].value !== '') {
        documentsWasUpdatedByUser(`${tmpData.requiredDocuments[itemIndex].item}`)
      }
      tmpData.requiredDocuments[itemIndex].requiredItems[i].value = updatedValue
      tmpData.requiredDocuments[itemIndex].requiredItems[i].url = updatedUrl
      break
    }
  }
  setMemberRequirement(tmpData)
  return
}

export const handleCarInsuranceUpload = async (file, itemName, item, setCarInsurancePicture, setUserUploadedInsurancePic,
  memberRequirement,setMemberRequirement, itemIndex, navigate, profileId) => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("inputType", "image");
  formData.append("itemName", itemName);
  formData.append("item", item);

  const config = {
    headers: {
      "content-type": "multipart/form-data",
      "upload-document": true,
      ...getAuthHeader(),
    },
  };

  try {
    const endpoint = `${ONBOARDING_API_ENDPOINT}/api/onboarding/updateConfiguration?profileType=${profileId}`;
    const res = await axios.post(endpoint, formData, config);

    setCarInsurancePicture(URL.createObjectURL(file))
    setUserUploadedInsurancePic(true)
    updateMemberRequirement(memberRequirement,setMemberRequirement, itemIndex, itemName, res.data.result.itemValue, res.data.result.url)
  } catch (err) {
    navigateToSessionExpired(navigate, {
      reason: "car_insurance_upload_failed",
      source: "handleCarInsuranceUpload",
      component: "CarInsurance",
      status: err?.response?.status,
      message: err?.message,
      item,
      itemName,
    });
  }
}

export const handleFileChange = async (e, itemName, setValidation, setInsuranceLoading, setCarInsurancePicture,
  setUserUploadedInsurancePic, memberRequirement,setMemberRequirement, itemIndex, navigate, selectedProfileType) => {
  let file = e.target.files[0];
  if (
    !["image/png", "image/jpeg", "image/jpg"].includes(file.type) ||
    file.size / 1000000 > 7
  ) {
    setValidation(true);
    return;
  }
  setInsuranceLoading(() => true);
  await handleCarInsuranceUpload(file, itemName, "carInsurance", setCarInsurancePicture, setUserUploadedInsurancePic, memberRequirement,setMemberRequirement, itemIndex, navigate, selectedProfileType.profileId)
  setValidation(false);
  setInsuranceLoading(() => false);
}

export const validateOnUpdate = (validationOnSubmit, carInsuranceDetails, setValidationOnSubmit, userUploadedInsurancePic) => {
  if (validationOnSubmit.show && carInsuranceDetails.carInsuranceCompany === "") {
    setValidationOnSubmit({
      show: true,
      message: "Provide valid name of the insurance company",
      class: "error-msg",
    });
    return false;
  } else if (
    validationOnSubmit.show &&
    (carInsuranceDetails.carInsuranceExpiryDate === "" ||
      moment(carInsuranceDetails.carInsuranceExpiryDate, "YYYY-MM-DD").diff(
        moment(),
        "years"
      ) < 1)
  ) {
    setValidationOnSubmit({
      show: true,
      message: "Provide valid insurance expiry date",
      class: "error-msg",
    });
    return false;
  } else if (validationOnSubmit.show && !userUploadedInsurancePic) {
    setValidationOnSubmit({
      show: true,
      message: "Missing image of you're motorcycle insurance",
      class: "error-msg",
    });
    return false;
  } else if (carInsuranceDetails.carInsuranceCompany === "" || carInsuranceDetails.carInsuranceExpiryDate === ""  || !userUploadedInsurancePic)  {
    setValidationOnSubmit({
      show: true,
      message: "Please fill in all the required fields before saving the document",
      class: "error-msg",
    });
  } else {
    setValidationOnSubmit({ show: false, message: "", class: "" });
    return true;
  }
}

export const handleSubmitDocument = async (carInsuranceDetails, profileId, memberRequirement,setMemberRequirement, itemIndex, setOpenUploadDocument, navigate) => {
  let body = {
    item: "carInsurance",
    requiredItems: [
      {
        itemName: "insuranceCompany",
        value: carInsuranceDetails.carInsuranceCompany,
      },
      {
        itemName: "insuranceExpiryDate",
        value: carInsuranceDetails.carInsuranceExpiryDate,
      },
    ],
  };
  const config = {
    headers: {
      "content-type": "application/json",
      "upload-document": false,
      ...getAuthHeader(),
    },
  };
  try {
    const endpoint = `${ONBOARDING_API_ENDPOINT}/api/onboarding/updateConfiguration?profileType=${profileId}`;
    const res = await axios.post(endpoint, body, config);
    if (res.status) {
      let tmpMemberData = { ...memberRequirement };

      for (
        let i = 0;
        i <
        tmpMemberData.requiredDocuments[itemIndex].requiredItems.length;
        i++
      ) {
        if (
          tmpMemberData.requiredDocuments[itemIndex].requiredItems[i]
            .itemName in carInsuranceDetails
        ) {
          updateMemberRequirement(
            memberRequirement,
            setMemberRequirement,
            itemIndex,
            tmpMemberData.requiredDocuments[itemIndex].requiredItems[i]
              .itemName,
              carInsuranceDetails[
              `${
                tmpMemberData.requiredDocuments[itemIndex]
                  .requiredItems[i].itemName
              }`
            ]
          );
        }
      }
      setOpenUploadDocument({ openDocument: false, documentType: "" });
    }
  } catch (error) {
    navigateToSessionExpired(navigate, {
      reason: "car_insurance_submit_failed",
      source: "handleSubmitDocument",
      component: "CarInsurance",
      status: error?.response?.status,
      message: error?.message,
      item: "carInsurance",
    });
  }
}